import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CacheService {
  clearCache() {
    const currentUrl = window.location.href;
    const cacheBuster = new Date().getTime();

    const hasVParameter = currentUrl.includes("v=");
    const newUrl = hasVParameter
      ? currentUrl.replace(/(v=)[^&]*/, `$1${cacheBuster}`)
      : `${currentUrl}${currentUrl.includes("?") ? "&" : "?"}v=${cacheBuster}`;

    window.location.href = newUrl;
  }
}
